import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { InjectHoverProvider } from 'modules/core/lib/hoverContext'

import type { ShiftsRow } from 'modules/shift_management/lib/types'

import WorkAreaCellContent from './WorkAreaCellContent'

interface WorkAreaCellProps {
  shiftsRow: ShiftsRow
}

const WorkAreaCell = ({ shiftsRow }: WorkAreaCellProps) => {
  return (
    <InjectHoverProvider>
      <Box
        background="grey000White"
        flexDirection="row"
        justifyContent="spaceBetween"
        height="full"
        paddingY="s8"
        paddingLeft="s16"
        paddingRight="s8"
      >
        <WorkAreaCellContent shiftsRow={shiftsRow} />
      </Box>
    </InjectHoverProvider>
  )
}

export default observer(WorkAreaCell)
